export const classData = {
    id: '5f2a0099e0849a7ebb12f868',
    number_of_students: 18,
    year: '7',
    name: 'Class 09-ad',
    teacher: 'Name Surname',
    comfortable: 4000,
    uncomfortable: 6000,
};
